// extracted by mini-css-extract-plugin
export default {"praise":"NewsCommentList_praise__R8Kz3"};